module.exports = __webpack_public_path__ + "static/media/bg1.69a9f51f.png";